// removed by extract-text-webpack-plugin
module.exports = {"container":"AsKxH","triangle":"_2qqLP","top":"_1rKEu"};


//////////////////
// WEBPACK FOOTER
// ./app/components/tooltip/tooltip.scss
// module id = 834
// module chunks = 3 4 5 6 7